import yup from '@/libs/yup';

export default yup.object().shape({
    idn: yup.string().required(),
    version: yup.string().required(),
    project_image_id: yup.string().required(),
    is_public: yup.boolean().required()
});
